/**
 * The associate id the PWA should act AS — the "effective" associate.
 *
 * On login the rep's associate record is stored in `localStorage['associate']`;
 * when an admin impersonates a rep, that same key is overwritten with the
 * impersonated rep, so reading `associate` already yields the effective
 * identity. We fall back to the `impersonating` payload defensively (older login
 * flows / belt-and-suspenders) and never REQUIRE impersonation to be set —
 * impersonation is respected when active, but a non-impersonating user resolves
 * to their own associate.
 *
 * Returns null when no associate is known (e.g. logged out, or a malformed
 * stored payload).
 *
 * This consolidates the per-page copies that previously lived in StoreDetail,
 * CallDetail, SetDetail, and Profile's Hard Reset resolver.
 */
export function getEffectiveAssociateId(): number | null {
  for (const key of ['associate', 'impersonating'] as const) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) continue;
      const a = JSON.parse(raw);
      const id = a?.associateid || a?.id || a?.AssociateID;
      if (id) return id as number;
    } catch {
      // Malformed entry — try the next source.
    }
  }
  return null;
}
